// HeaderVideoBinder.jsx
import React, { useState, useEffect } from 'react';
import VideoMenuBinder from './VideoMenuBinder';
import JsonService from './JsonService';

export default function HeaderVideoBinder({
  content_url = '/landers/artlab.json',
  width = null,
  maxWidth = null,
  className = '',
  displayStyle = 'square',
  style
}) {
  const [cfg, setCfg] = useState(null);

useEffect(() => {
  const ctrl = new AbortController();
  (async () => {
    try {
      // Section files are already a video_menu_binder JSON (no "sections" list)
      const j = await JsonService.fetchJson({ url: content_url, signal: ctrl.signal, cache: 'no-store' });
      if (j?.render_control_type === 'video_menu_binder') {
        setCfg({
          initial_scene: j.initial_scene,
          loops: j.loops,
          transitions: j.transitions,
          buttons: j.buttons,
        });
      } else {
        console.warn('HeaderVideoBinder: expected video_menu_binder JSON at', content_url, j);
        setCfg(null);
      }
    } catch (e) {
      console.warn('HeaderVideoBinder load failed:', e);
      setCfg(null);
    }
  })();
  return () => ctrl.abort();
}, [content_url]);

  if (!cfg) return null;
  // if( style == null){
  //   style = { width, maxWidth };
  // }else{
  //   style["width"] = width;
  //   style["maxWidth"] = maxWidth;
  // }
  // const mergedStyle = { ...(style || {}) };
  // if (width != null) mergedStyle.width = width;
  // if (maxWidth != null) mergedStyle.maxWidth = maxWidth;

  return (

      <VideoMenuBinder
        initial_scene={cfg.initial_scene}
        loops={cfg.loops}
        transitions={cfg.transitions}
        buttons={cfg.buttons}
        displayStyle={displayStyle}
        style={style}
        className={className}
      />
  );
}
